export const MEDICARE_CARD_COLOR_GREEN = 'GREEN';
export const MEDICARE_CARD_COLOR_BLUE = 'BLUE';
export const MEDICARE_CARD_COLOR_YELLOW = 'YELLOW';

export const medicareCardType = [
  { title: 'medicare.card_color.green', type: MEDICARE_CARD_COLOR_GREEN, intl: true },
  { title: 'medicare.card_color.blue', type: MEDICARE_CARD_COLOR_BLUE, intl: true },
  { title: 'medicare.card_color.yellow', type: MEDICARE_CARD_COLOR_YELLOW, intl: true },
];

export const medicareCardTypeValues = medicareCardType.map((item) => item.type);
